<template>
  <div>
    <div class="task_form_title">
      <i class="el-icon-close" @click="closeTaskForm"></i>
    </div>
    <div class="task_form_c">
      <el-form :model="formObj" :rules="formRules" ref="formObj" label-width="120px" >
        <el-form-item label="名称" prop="text">
          <el-input v-model="formObj.text" placeholder="请输入名称" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="时间" prop="time">
          <el-date-picker
            v-model="formObj.time"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="关联模型">
          <el-select v-model="formObj.relation" placeholder="关联模型" @change="checkRelation">
            <el-option  v-for="(item,index) in tools" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="warning" @click.native="doDelete(option)">删除</el-button>
        <el-button @click.native="doCancel">取消</el-button>
        <el-button type="primary" @click.native="doSubmit(option)">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {createTask,updateTask,delTask} from '../../api/api'
  export default {
    name: "ModelForm",
    props: {
      option: 0,
      formData:{},
      type:0
    },
    data(){
      return {
        formObj: {time:null,text:null,relation:null},
        formRules: {
          text: [
            {required: true, message: '请输入计划名称', trigger: 'blur'}
          ],
          time: [
            {required: true, message: '请选择时间区间', trigger: 'change'}
          ]
        },
        tools:[{id:1,name:'关联选中'},{id:2,name:'非关联'}],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },

      }
    },
    methods:{
      checkRelation:function(){
          if(hasSelectionIds.length==0 && this.formObj.relation==1){
            this.$message({
              message: '当前没有选中项',
              type: 'error'
            })
            this.formObj.relation = 2;
          }else if (hasSelectionIds.length>=500){
            this.$message({
              message: '关联构件过多，最多500个',
              type: 'error'
            })
            this.formObj.relation = 2;
          }
      },
      doSubmit: function (option) {

        this.$refs.formObj.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {type: 'warning'}).then(() => {
              let rangTime = this.formObj.time + ''
              let beginTime = null, endTime = null;
              if (rangTime) {
                beginTime = rangTime.split(',')[0]
                beginTime = new Date(beginTime)
                endTime = rangTime.split(',')[1];
                endTime = new Date(endTime).setDate((new Date(endTime).getDate()+1));
                endTime = new Date(endTime);
                //endTime = new Date(endTime.getFullYear(), endTime.getMonth(), endTime.getDate()+1)
              }

              this.formObj.startDate = beginTime
              this.formObj.endDate = endTime;
              let duration = Math.ceil((endTime.getTime()-beginTime.getTime())/86400000);
              this.formObj.duration = duration;
              if(this.formObj.relation==1){
                this.formObj.actor = hasSelectionIds.join("#");
              }
              if (option == 0) {

                createTask(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: '创建成功',
                      type: 'success'
                    })
                    this.$emit('doSubmit');
                  }
                });
              }
              else if (option == 1) {
                this.formObj.option = 2;
                updateTask(this.formObj, this.GLOBAL.header).then(result => {
                  if (result.success) {
                    this.$message({
                      message: '修改成功',
                      type: 'success'
                    })
                    this.$emit('doSubmit');
                  }
                });
              }
            }).catch(() => {
            });
          }
        });


      },
      doCancel:function(){
        this.$emit('doCancel');
      },
      doDelete:function(){
        this.$confirm('确认删除吗？', '提示', {type: 'warning'}).then(() => {
          delTask({id: this.formObj.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.$message({
                message: '删除成功',
                type: 'success'
              })
              this.$emit('doDelete');
            }
          });
        }).catch(() => {
        });
      },
      closeTaskForm:function(){
        this.$emit('closeTaskForm');
      }
    },
    mounted() {
      //初始化表单数据
      let task= this.formData;
      let endTime = new Date(task.end_date).setDate((new Date(task.end_date).getDate()-1));
      let timeRange = [];
      timeRange.push(task.start_date);
      timeRange.push(new Date(endTime));

      this.formObj.time = timeRange;
      this.formObj.text = task.text;
      this.formObj.parent = task.parent;
      this.formObj.proId=task.proId;
      this.formObj.scheduledId = task.scheduledId;
      this.formObj.status = 1;
      this.formObj.progress = task.progress;
      this.formObj.id = task.id;
      this.formObj.actor = task.actor;
      if(hasSelectionIds.length>0 && this.option ==1){
        this.formObj.relation = 1;
      }else{
        this.formObj.relation = 2;
      }
    },
    destroyed() {

    }
  }
</script>

<style scoped>
.task_form_title{padding: 10px;text-align: right;}
.el-icon-close{cursor: pointer;}
.task_form_c{ margin-right: 20px;}
</style>



// WEBPACK FOOTER //
// src/components/progress/TaskForm.vue